export const clearUserBookingStorage = () => {
    localStorage.removeItem("persist:root"); // checkout/booking state
    sessionStorage.removeItem("persist:ma"); // my-account state
};
